var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"outerDom",attrs:{"id":"app"},on:{"scroll":_vm.handleScroll}},[(_vm.falg)?_c('Nav'):_vm._e(),_c('router-view'),(_vm.falg)?_c('Footer'):_vm._e(),_c('el-backtop',{attrs:{"target":"#app","bottom":100}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }